import { create } from 'zustand';
import type { BenefitPaymentType } from '@/features/shop-insurance/types';

export type BenefitPaymentTypeFilter = BenefitPaymentType | 'all';

interface BenefitTypeFilterState {
  selectedBenefitPaymentType: BenefitPaymentTypeFilter;
  actions: {
    setSelectedBenefitPaymentType: (value: BenefitPaymentTypeFilter) => void;
    reset: () => void;
  };
}

const DEFAULT_BENEFIT_PAYMENT_TYPE: BenefitPaymentTypeFilter = 'all';

export const useBenefitTypeFilterStore = create<BenefitTypeFilterState>(set => ({
  selectedBenefitPaymentType: DEFAULT_BENEFIT_PAYMENT_TYPE,
  actions: {
    setSelectedBenefitPaymentType: value => set({ selectedBenefitPaymentType: value }),
    reset: () => set({ selectedBenefitPaymentType: DEFAULT_BENEFIT_PAYMENT_TYPE }),
  },
}));

export const useSelectedBenefitPaymentType = () =>
  useBenefitTypeFilterStore(state => state.selectedBenefitPaymentType);

export const useBenefitTypeFilterActions = () =>
  useBenefitTypeFilterStore(state => state.actions);
